import { makeSvgIcon } from '../makeSvgIcon'

export const wave = makeSvgIcon(
  <path d="M5.0359 7.93782C1.5718 9.93782 0.973726 14.9019 3.47372 19.232C4.20578 16.5 6.30385 14.134 9.0359 14.866C11.768 15.5981 15.5 18.0622 18.9641 16.0622C22.4282 14.0622 23.0263 9.09807 20.5263 4.76795C18.9282 8 17.6962 9.86602 14.9641 9.13397C12.2321 8.40192 8.5 5.93782 5.0359 7.93782Z" />
)
